import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router'
import { Subscription } from 'rxjs/Subscription'
import { Source } from 'app/models/source.enum'
import { CompetitionService } from 'app/services/competition.service'
import { Competition } from 'app/models/competition'
import { GuideComponent } from 'app/shared/components/guide/guide.component'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: []
})
export class HomeComponent implements OnInit, OnDestroy {
  competition: Competition
  date: Date = new Date()
  bsModalRef: BsModalRef
  transitionReady: boolean
  private routerSub = Subscription.EMPTY
  @Output('imgUrl') imgUrl = new EventEmitter()

  constructor(
    private modalService: BsModalService,
    private competitionService: CompetitionService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.routerSub = this.router.events.filter(event => event instanceof NavigationEnd)
      .map(event => event)
      .subscribe((val) => {
        this.competition = this.competitionService.getCompetitionSelected()
        this.loginActions()
        this.activateTransition()
      })
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.routerSub.unsubscribe()
  }

  private loginActions() {
    if (sessionStorage.getItem('first-start') === 'true') {
      sessionStorage.removeItem('first-start')
      this.openGuide()
    }
  }

  requestFile(fileSortingType, source: Source) {
    // should request resouces from server
    console.log(fileSortingType)
  }

  openGuide() {
    this.bsModalRef = this.modalService.show(GuideComponent, {
      class: 'gray modal-lg',
      backdrop: 'static'
    })
  }

  // TODO workaround to make the animation till the service is actived.
  activateTransition(): void {
    setTimeout(res => {
      this.transitionReady = true
    }, 200)
  }
}



// WEBPACK FOOTER //
// ./src/app/views/home/home.component.ts